export default __webpack_public_path__ + "static/rsz_kasia-b5c0db975aadd8dca9c445d4c01a5717.png";